import { FC } from "react";
import { TableBody, TableRow, TableCell, Typography } from "@mui/material";

const ERROR_MESSAGE = "Failed to load collections";

export const CollectionsTableErrorState: FC = () => {
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={5} align="center">
          <Typography variant="body2" color="error">
            {ERROR_MESSAGE}
          </Typography>
        </TableCell>
      </TableRow>
    </TableBody>
  );
};
